(function () {
  const root = document.getElementById('GeekoGiftcardActivate');
  if (!root) return;

  const config = window.geekoGiftcardActivateConfig || {};
  const strings = config.strings || {};

  const stateEls = {
    loading: root.querySelector('[data-gc-state="loading"]'),
    success: root.querySelector('[data-gc-state="success"]'),
    error: root.querySelector('[data-gc-state="error"]'),
  };

  const codeEl = root.querySelector('[data-gc-code]');
  const successLabelEl = root.querySelector('[data-gc-success-label]');
  const discountRow = root.querySelector('[data-gc-discount-row]');
  const discountEl = root.querySelector('[data-gc-discount]');
  const expiresRow = root.querySelector('[data-gc-expires-row]');
  const expiresEl = root.querySelector('[data-gc-expires]');
  const errorMsgEl = root.querySelector('[data-gc-error-msg]');
  const retryBtn = root.querySelector('[data-gc-retry]');
  const copyBtn = root.querySelector('[data-gc-copy]');
  const copyLabelEl = root.querySelector('[data-gc-copy-label]');
  const shopLink = root.querySelector('[data-gc-shop]');

  let lastToken = null;
  let activatingRetryTimer = null;

  function showState(name) {
    Object.keys(stateEls).forEach(function (key) {
      if (!stateEls[key]) return;
      stateEls[key].classList.toggle('hidden', key !== name);
    });
  }

  function getToken() {
    try {
      return new URLSearchParams(window.location.search).get('t');
    } catch (_) {
      return null;
    }
  }

  function mapErrorMessage(code, fallback) {
    var c = Number(code);
    if (c === 40401) return strings.error_not_found || fallback;
    if (c === 40901) return strings.error_void || fallback;
    if (c === 40903) return strings.error_activating || fallback;
    if (c === 50001 || c === 500) return strings.error_shopify || fallback;
    return fallback || strings.error_generic;
  }

  function formatDiscount(data) {
    var type = data.discount_type || data.discountType;
    var value = data.discount_value != null ? data.discount_value : data.discountValue;
    var currency = data.currency || 'USD';
    if (value == null || value === '') return '';

    if (type === 'percentage') {
      var tpl = strings.discount_percentage || '__VALUE__% OFF';
      return tpl.replace(/__VALUE__/g, String(value));
    }
    if (type === 'fixed_amount') {
      var fixedTpl = strings.discount_fixed || '__CURRENCY__ __VALUE__ OFF';
      return fixedTpl
        .replace(/__CURRENCY__/g, String(currency))
        .replace(/__VALUE__/g, String(value));
    }
    return String(value);
  }

  function formatExpires(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (Number.isNaN(d.getTime())) return String(iso);
      return d.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (_) {
      return String(iso);
    }
  }

  function renderSuccess(data) {
    var code = data.coupon_code || data.couponCode || '';
    if (codeEl) codeEl.textContent = code;

    if (successLabelEl) {
      var again = data.first_activate === false || data.firstActivate === false;
      successLabelEl.textContent = again
        ? strings.success_again || strings.success_label || 'Your discount code'
        : strings.success_label || 'Your discount code is ready';
    }

    var discountText = formatDiscount(data);
    if (discountRow && discountEl) {
      if (discountText) {
        discountEl.textContent = discountText;
        discountRow.classList.remove('hidden');
      } else {
        discountRow.classList.add('hidden');
      }
    }

    var expiresText = formatExpires(data.expires_at || data.expiresAt);
    if (expiresRow && expiresEl) {
      if (expiresText) {
        expiresEl.textContent = expiresText;
        expiresRow.classList.remove('hidden');
      } else {
        expiresRow.classList.add('hidden');
      }
    }

    if (shopLink && config.shopUrl) {
      shopLink.setAttribute('href', config.shopUrl);
    }

    showState('success');
  }

  function renderError(message, canRetry) {
    if (errorMsgEl) errorMsgEl.textContent = message || strings.error_generic;
    if (retryBtn) retryBtn.classList.toggle('hidden', !canRetry);
    showState('error');
  }

  function activate(token, isRetry) {
    lastToken = token;
    showState('loading');

    var endpoint = (config.apiEndpoint || '').replace(/\/$/, '');
    if (!endpoint) {
      renderError(strings.error_generic, false);
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ token: token }),
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var json = null;
          if (text && text.trim()) {
            try {
              json = JSON.parse(text);
            } catch (_) {
              json = null;
            }
          }
          return { ok: res.ok, status: res.status, json: json, text: text };
        });
      })
      .then(function (payload) {
        var json = payload.json;
        if (!json) {
          renderError(strings.error_generic, true);
          return;
        }

        // JResult: success + result
        if (json.success === true && json.result) {
          var result = json.result;
          if (typeof result === 'object' && (result.coupon_code || result.couponCode)) {
            renderSuccess(result);
            return;
          }
        }

        var code = json.code;
        var failPayload = json.result != null ? json.result : json.message;
        var failText =
          typeof failPayload === 'string'
            ? failPayload
            : mapErrorMessage(code, strings.error_generic);

        // Concurrent activating: auto-retry once after short delay
        if (Number(code) === 40903 && !isRetry) {
          renderError(mapErrorMessage(40903, failText), true);
          if (activatingRetryTimer) clearTimeout(activatingRetryTimer);
          activatingRetryTimer = setTimeout(function () {
            activate(token, true);
          }, 1500);
          return;
        }

        var canRetry =
          Number(code) === 40903 ||
          Number(code) === 50001 ||
          Number(code) === 500 ||
          !payload.ok;

        renderError(mapErrorMessage(code, failText), canRetry);
      })
      .catch(function () {
        renderError(strings.error_network || strings.error_generic, true);
      });
  }

  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      var text = codeEl.textContent || '';
      if (!text) return;

      var done = function () {
        if (copyLabelEl) {
          copyLabelEl.textContent = strings.copied || 'Copied';
          setTimeout(function () {
            copyLabelEl.textContent = strings.copy || 'Copy';
          }, 1600);
        }
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {
          fallbackCopy(text, done);
        });
      } else {
        fallbackCopy(text, done);
      }
    });
  }

  function fallbackCopy(text, done) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      if (done) done();
    } catch (_) {
      /* ignore */
    }
  }

  if (retryBtn) {
    retryBtn.addEventListener('click', function () {
      if (lastToken) activate(lastToken, true);
    });
  }

  var token = getToken();
  if (!token) {
    renderError(strings.error_invalid_link || 'Invalid link', false);
    return;
  }

  activate(token, false);
})();
